/*
 * @Author: liuqing
 * @Date: 2021-01-23 10:31:40
 * @LastEditors: zhujiapeng
 * @LastEditTime: 2021-02-02 16:44:49
 * @Description: 红橙主题
 * @Copyright: © 2020 杭州杰竞科技有限公司 版权所有
 */
import React from 'react';

function RedOrangeTheme() {
  return (
    <React.Fragment>
      <img className="red_orange_bg" src="https://image.xiaomaiketang.com/xm/7GkSRkYWP6.png" alt="" />
      <img className="circle circle_top" src={require('../../images/theme/circle.png')} alt="" />
      <img className="circle circle_bottom" src={require('../../images/theme/circle.png')} alt="" />
      <img className="red_orange_body_bg" src='https://image.xiaomaiketang.com/xm/hce6fpNi7w.png' alt="" />
    </React.Fragment>
  )
}

export default RedOrangeTheme;
